export function resolveScrollDock(input: { enabled: boolean; top: number; bottom: number; viewportHeight: number; seen: boolean; dismissed: boolean; floating: boolean }) {
  const visible = input.bottom > 24 && input.top < input.viewportHeight - 24;
  const seen = input.seen || visible;
  const dismissed = visible ? false : input.dismissed;
  return { seen, dismissed, floating: input.enabled && seen && !dismissed && (input.floating ? !visible : input.bottom < 0) };
}
